// temp data
const chat = ['1000', '1001']

export default chat



// WEBPACK FOOTER //
// ./src/store/chat.js